import { Component, Input, OnInit } from "@angular/core";
import { LabAccess, LabsPageService } from "../labs-page.service";
import { NzModalRef } from "ng-zorro-antd/modal";

@Component({
  selector: "app-modal-edit-access",
  templateUrl: "./modal-edit-access.component.html",
  styleUrls: ["./modal-edit-access.component.scss"],
})
export class ModalEditAccessComponent implements OnInit {
  @Input() data?: any;
  public reportType: any[] = [];
  public accessType: any;
  public accessEA = true;
  public accessEAAndLabs = false;
  public accesslbl = "";
  constructor(
    private modal: NzModalRef,
    public labsPageService: LabsPageService,
  ) {}

  ngOnInit() {
    this.reportType = this.data === null ? [] : this.data.reportType;
    this.accessType = this.data === null ? [] : this.data.accessType;
    //this.accessEA = this.checkUserAccessContains(LabAccess.EA,this.accessType.userAccess)
    this.accessEAAndLabs = this.checkUserAccessContains(
      LabAccess.EA_AND_LABS,
      this.accessType.userAccess,
    );
    if (this.accessType.userAccess === LabAccess.EA) {
      this.accesslbl = `2: ${
        this.reportType.find((x) => x.name === this.accessType.userAccess)
          .displayname
      }`;
    }
    if (this.accessType.userAccess === LabAccess.EA_AND_LABS) {
      this.accesslbl = `3: ${
        this.reportType.find((x) => x.name === this.accessType.userAccess)
          .displayname
      }`;
    }
  }

  public checkUserAccessContains(accessType: string, userAccess: string) {
    return userAccess.includes(accessType);
  }

  public submitChange() {
    if (this.accessType.firmAccess === LabAccess.EA_AND_LABS) {
      if (
        this.accessType.userAccess === LabAccess.EA_AND_LABS &&
        !this.accessEAAndLabs
      ) {
        this.updateUserAccess(LabAccess.EA);
      }
      if (this.accessType.userAccess === LabAccess.EA && this.accessEAAndLabs) {
        this.updateUserAccess(LabAccess.EA_AND_LABS);
      }
    }

    if (this.accessType.firmAccess === LabAccess.EA) {
      if (this.accessType.userAccess === LabAccess.EA && this.accessEAAndLabs) {
        this.accessElevationRequest();
      }
      if (
        this.accessType.userAccess === LabAccess.EA_AND_LABS &&
        !this.accessEAAndLabs
      ) {
        this.updateUserAccess(LabAccess.EA);
      }
    }
    //this.modal.destroy({ status: 'success', message: 'Your access has been changed to Level 2: Stable, Testing Reports.' });
  }

  public updateUserAccess(accessType: LabAccess) {
    let message = "";
    const accessTemp = this.reportType.find((x) => x.name === accessType);
    message = `Your access has been changed to Level ${accessTemp.level}: ${accessTemp.displayname}.`;

    this.labsPageService.updateUserAccess(accessType).subscribe((res) => {
      if (res.status === "success") {
        this.accessType.userAccess = accessType;
        const responce = {
          status: "success",
          type: "update",
          accessType: accessType,
          message: message,
        };
        this.modal.destroy(responce);
      }
      if (res.status === "error") {
        const responce = {
          status: "success",
          type: "update",
          accessType: accessType,
          message: res.message,
        };
        this.modal.destroy(responce);
      }
    });
  }

  public accessElevationRequest() {
    const accessTemp = this.reportType.find(
      (x) => x.name === LabAccess.EA_AND_LABS,
    );
    const message = `Your request for access Level ${accessTemp.level}: ${accessTemp.displayname} send successfully.`;
    const responce = {
      status: "success",
      type: "request",
      message: message,
    };
    this.modal.destroy(responce);
  }

  public destroyModal() {
    this.modal.destroy();
  }
}
